import { service } from '@ember/service';

import type { Service } from 'webapp-types';
import { PopupEvent } from 'webapp/enums/enums';
import { TourId } from 'webapp/enums/tour';
import { UserSettingsKey } from 'webapp/enums/user-settings';

import TourBase from 'webapp/models-custom/tour';

export default class QbSheetsVideoTour extends TourBase {
	@service('navigation') declare navigationService: Service.Navigation;

	static keyForPersistantDone = UserSettingsKey.QB_GSHEETS_VIDEO;
	popupName = '';

	afterMarkDone: (() => void) | null = null;

	constructor(opts?: Record<string, unknown>) {
		super();

		if (opts?.afterMarkDone) {
			this.afterMarkDone = opts.afterMarkDone as () => void;
		}
	}

	get id(): string {
		return TourId.QB_SHEETS_VIDEO;
	}

	override get keyForPersistantDone(): string {
		return QbSheetsVideoTour.keyForPersistantDone;
	}

	override start(): void {
		super.start();
		const popup = this.navigationService.openGoogleSheetsVideoPopup('sheets_wizard');

		if (popup) {
			popup.on(PopupEvent.CLOSING, this, () => {
				this.markDone(); // just one step, once seen, it's done

				if (this.afterMarkDone) {
					this.afterMarkDone();
				}
			});
		}
	}
}
